import { observable, action, decorate } from "mobx";
class LateUserStore {
    // observable
    listLateUsers = [];
    listConsignee = '';

    // action
    updateListLateUser = updatedList => {
        this.listLateUsers = updatedList;
    }
    updateListConsignee = updatedData => {
        this.listConsignee = updatedData;
    }
    addListConsignee = newDate => {
        let updated = this.listConsignee.concat((this.listConsignee ? ';' : ''), newDate);
        this.listConsignee = updated;
    }
}
decorate(LateUserStore, {
    listLateUsers: observable,
    listConsignee: observable,
    updateListConsignee: action,
    addListConsignee: action,

});
export default new LateUserStore();